import type { CompleteOrientationResponse } from "@ts/interfaces/orientation/api/orientationApiInterfaces";
import { post } from "./httpClient";

export const completeOrientation = async (
  gradeCode: number
): Promise<CompleteOrientationResponse> => {
  return await post<CompleteOrientationResponse>(
    `/user/complete-orientation/${gradeCode}`,
    {}
  );
};

export const orientationApi = {
  completeOrientation
};
